import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../shared/core/state';
import { Router } from '@angular/router';
import { Pagination } from '../../shared/models/pagination.model';
import { LiveClass } from '../../shared/core/state/live-class/models/live-class';
import * as LiveClassActions from '../../shared/core/state/live-class/live-class.action';
import { SubscriptionStatus } from '../../shared/core/state/subscription/subscription.model';
import { FormatterService } from '../../shared/util/formatter.service';
import { toLiveClassCardViewModel } from '../../shared/util/ui-card.mapper';
import { UiCardViewModel } from '@black/ui';
import { TenantService, TenantInfo } from '../../shared/services/tenant.service';

@Component({
  selector: 'black-explore-live-classes',
  templateUrl: './explore-live-classes.component.html',
  styleUrl: './explore-live-classes.component.css',
  standalone: false,
})
export class ExploreLiveClassesComponent implements OnInit {
  private store = inject<Store<State>>(Store);
  private router = inject(Router);
  private formatter = inject(FormatterService);
  public tenantService = inject(TenantService);

  liveClasses: LiveClass[] = [];
  liveClassCards: UiCardViewModel[] = [];
  currentTenant: TenantInfo | null = null;
  isLoading = true;

  pagination: Pagination = {
    totalDocs: 0,
    limit: 0,
    totalPages: 0,
    page: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: 0,
    nextPage: 0,
  };

  totalPagesRange: number[] = [];

  ngOnInit(): void {
    this.tenantService.currentTenant$.subscribe((tenant) => {
      this.currentTenant = tenant;
    });

    this.store.dispatch(LiveClassActions.fetchAllLiveClasses({ page: 1 }));

    this.store
      .select((state) => state.liveClass.liveClassItems)
      .subscribe((items) => {
        this.liveClasses = items;
        this.liveClassCards = items.map((item) =>
          toLiveClassCardViewModel(item, this.formatter, {
            isEnrolled: this.hasValidSubscription(item),
            submitButtonText: 'Subscribe Now',
          })
        );
        this.isLoading = false;
      });

    this.store
      .select((state) => state.liveClass.pagination)
      .subscribe((result) => {
        this.pagination = result;
        this.totalPagesRange = new Array(
          this.pagination.totalPages <= 0 ? 0 : this.pagination.totalPages - 1
        );
      });
  }

  createRange(length: number, currentPage: number) {
    return new Array(length).fill(0).map((n, index) => index + 1);
  }

  paginateItems(page: number) {
    this.isLoading = true;
    this.store.dispatch(LiveClassActions.fetchAllLiveClasses({ page }));
  }

  onClickLiveClass(id: string) {
    this.router.navigate(['live-classes', id]);
  }

  onClickSubscribe(id: string) {
    this.router.navigate(['live-classes', id, 'subscribe']);
  }

  onClickContinue(id: string) {
    this.router.navigate(['meetings']);
  }

  onClickJoinMeetings(id: string) {
    this.router.navigate(['meetings']);
  }

  onClickAccessResources(id: string) {
    this.router.navigate(['dashboard', 'learning', 'live-class', id]);
  }

  hasValidSubscription(liveClass: LiveClass) {
    const subscription = liveClass.subscriptions;
    if (!subscription || !Array.isArray(subscription)) return false;
    return subscription.some((sub) =>
      [
        SubscriptionStatus.ACTIVE,
        SubscriptionStatus.COMPLETE,
        SubscriptionStatus.PENDING,
        SubscriptionStatus.RENEWAL_DUE,
      ].includes(sub.status)
    );
  }
}
